const options = {
  5: "bg-yellow-900/5",
  10: "bg-yellow-900/10",
  25: "bg-yellow-900/25",
  50: "bg-yellow-900/50",
  75: "bg-yellow-900/75",
  90: "bg-yellow-900/90",
  100: "bg-yellow-900",
};

const from = {
  5: "from-yellow-900/5",
  10: "from-yellow-900/10",
  25: "from-yellow-900/25",
  50: "from-yellow-900/50",
  75: "from-yellow-900/75",
  90: "from-yellow-900/90",
  100: "from-yellow-900",
};

export default function getBackgroundYellow900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
